import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import CxExperienceActions from '../actions/cx-experience.actions';
import { CxExperience } from '../../models/experience';
import { CxCustomerExperienceResponse } from '../../../cx-customer/models/customer-experiences';
import CxCustomerActions from '../../../cx-customer/store/actions/cx-customer.actions';

export type CxExperienceEntity = CxExperience;
export interface CxExperienceState extends EntityState<CxExperienceEntity> {
  activeEntityId: string;
  customers: CxCustomerExperienceResponse;
}

export const entityAdapter = createEntityAdapter<CxExperienceEntity>({
  selectId: ({ uId }) => `${uId}`,
});

export const initialCxExperienceState = entityAdapter.getInitialState({
  activeEntityId: null,
});

export const cxExperienceReducer = createReducer(
  initialCxExperienceState,

  on(CxExperienceActions.selectEntity, (state, { id: activeEntityId }) => {
    return {
      ...state,
      activeEntityId,
    };
  }),

  on(CxExperienceActions.updateEntity, (state, { payload }) => entityAdapter.upsertOne(payload, state)),
  on(CxExperienceActions.updateEntities, (state, { payload }) => entityAdapter.upsertMany(payload, state)),
  on(CxCustomerActions.fetchCustomerExperiencesFilteredComplete, (state, { customers }) => {
    return {
      ...state,
      customers,
    };
  }),
  on(CxCustomerActions.fetchCustomerExperiencesFilteredFailed, (state, { response }) => {
    return {
      ...state,
      customers: null,
    };
  }),
);

export function reducer(state: CxExperienceState, action: Action) {
  return cxExperienceReducer(state, action);
}

export const selectActiveEntityId = (state: CxExperienceState) => state.activeEntityId;
export const { selectIds, selectEntities, selectAll, selectTotal } = entityAdapter.getSelectors();
export const selectCustomerExperiencesFiltered = (state: CxExperienceState) => state.customers;
